import React from 'react';
import styled from 'styled-components';

const ChatStart2 = () => {
  return (
    <StyledWrapper>
      <div className="ChatStart2">
        <button className="btn btn-hover">
          <span className="btn-text">Practice now</span>
        </button>
      </div>
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  .ChatStart2 {
    --transition: all 0.55s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    --yellow-bg: transparent linear-gradient(114deg, #fdc100 0%, #dd7d00 100%) 0%
      0% no-repeat padding-box;
    color: white;
    margin: 0;
  }

  .btn {
    border-radius: 23px;
    letter-spacing: 0.8px;
    font-size: 14px;
    font-weight: 300;
    color: white;
    white-space: nowrap;
    margin: 20px auto;
    width: 166px;
    height: 45px;
    cursor: pointer;
    position: relative;
    border: 1px solid #dd7d00;
    background: transparent;
  }

  .btn::before {
    -webkit-transition: var(--transition);
    transition: var(--transition);
    content: "";
    width: 50%;
    height: 100%;
    background: black;
    position: absolute;
    top: 0;
    right: 0;
  }

  .btn:hover::before {
    width: 100%;
  }

  .btn.btn-hover {
    border-radius: 50px;
    position: relative;
  }

  .btn.btn-hover .btn-text {
    color: white;
    -webkit-transition: var(--transition);
    transition: var(--transition);
    mix-blend-mode: lighten;
  }

  .btn.btn-hover::before {
    border-radius: 50px;
    width: 100%;
    background: conic-gradient(
      transparent 240deg, #ac633697 240deg,
      #fff2af6a 300deg, transparent 300deg
    )
    100% / 64%
    no-repeat, var(--yellow-bg);
  }

  .btn.btn-hover:hover .btn-text {
    margin-right: 30px;
  }

  .btn.btn-hover:hover::before {
    background-position: right;
    border-radius: 23px;
    width: 25%;
  }`;

export default ChatStart2;
